"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var base_condition_1 = require("./base.condition");
var TimeSpentCondition = /** @class */ (function (_super) {
    __extends(TimeSpentCondition, _super);
    function TimeSpentCondition(options, notificationService) {
        var _this = _super.call(this, "TimeSpentCondition", notificationService) || this;
        _this.observable = new Observable_1.Observable(function (observer) {
            // resolve to true in N seconds
            var timer = setTimeout(function () { return observer.next(true); }, options.AtLeast * 1000);
            // teardown logic
            return function () { return clearTimeout(timer); };
        });
        return _this;
    }
    return TimeSpentCondition;
}(base_condition_1.BaseCondition));
exports.TimeSpentCondition = TimeSpentCondition;
